import React, { FC } from 'react';
import { startCase } from 'lodash';

import { Counter } from '@/components';
import { NOT_DEFINED } from '@/constants';

import {
  ProductActionFavorite,
  ProductBadgeContainer,
  ProductCategory,
  ProductImage,
  ProductInfo,
  ProductInfoPack,
  ProductLinkWrapper,
  ProductName,
  ProductPrice,
  ProductVariants,
} from '../Product.components';
import { ProductVariationProps } from '../Product';
import { useProductContext } from '../context';

import classNames from 'classnames';

import style from '../product.module.scss';
import styleVariation from './ProductCardLarge.module.scss';

const ProductCardLarge: FC<ProductVariationProps> = ({
  className,
  analyticsListName,
  onKiosk,
  isAddToCartInKioskDisabled,
  onKioskAddClicked,
}) => {
  const { product, isSpecial, weightVariant, compoundList } =
    useProductContext();

  return (
    <ProductLinkWrapper
      analyticsListName={analyticsListName}
      className={classNames(style.product, styleVariation.product, className)}
      onKiosk={onKiosk}
      product={product}
    >
      <div className={styleVariation.product__header}>
        <ProductBadgeContainer
          className={styleVariation.product__badges_container}
          onKiosk={onKiosk}
          product={product}
          weightVariant={weightVariant}
        />
        <ProductName
          className={styleVariation.product__name}
          name={product?.name || NOT_DEFINED}
        />
        <ProductActionFavorite
          className={styleVariation.favorite_action}
          product={product}
        />
      </div>
      <div className={styleVariation.product__body}>
        <div className={styleVariation.product__brand_container}>
          <ProductInfo
            className={styleVariation.variation__info_badge}
            info={product.brand_name || NOT_DEFINED}
            key="info-brand"
            showLabel
            type="default"
          />
          <div className={styleVariation.product__image_container}>
            <ProductImage
              className={styleVariation.product__image}
              product={product}
            />
          </div>
        </div>
        <div className={styleVariation.product__body_info}>
          <ProductCategory
            className={styleVariation.product__category}
            info={product?.flower_type!}
            label="STRAIN"
            showLabel
            type="default"
          />
          <ProductInfo
            className={styleVariation.product__info_badge}
            info={startCase(product?.subcategory || NOT_DEFINED)}
            label="CATEGORY"
            showLabel
            type="default"
          />
          <ProductInfoPack
            className={styleVariation.product__per_pack}
            compoundList={compoundList}
            label="PER PACK"
            showIcon
          />
          <ProductVariants label="SELECT VARIATION" type="carousel" />
        </div>
      </div>
      <div className={styleVariation.product__footer}>
        <ProductPrice
          className={styleVariation.product__price_container}
          isSpecial={isSpecial}
          type="inverted"
          weightVariant={weightVariant}
        />
        {onKiosk && isAddToCartInKioskDisabled ? null : (
          <Counter
            actionTheme="primary"
            className={styleVariation.actions__counter}
            onCard
            onKiosk={onKiosk}
            onKioskAddClicked={onKioskAddClicked}
            product={product}
            selectedWeightVariant={weightVariant}
            showIcon
          />
        )}
      </div>
    </ProductLinkWrapper>
  );
};

export { ProductCardLarge };
